module.exports = __webpack_public_path__ + "media/images/icon__point--text@2x-1d962f03972ea7f46f17a899413211df.png";